export const CATEGORIES = [
    {
        key: "sandwiches",
        name: "السندوتشات",
        icon: "fa-burger",
        image: "https://images.unsplash.com/photo-1603614550145-c7bb90bbfddf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxmYXN0JTIwZm9vZCUyMGJ1cmdlciUyMG1lYWx8ZW58MHx8fHwxNzgyMDQ2OTY0fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        key: "snacks",
        name: "قسم التسالي",
        icon: "fa-fire",
        image: "https://images.pexels.com/photos/5779487/pexels-photo-5779487.jpeg",
    },
    {
        key: "drinks",
        name: "المشروبات والعصيرات",
        icon: "fa-glass-water",
        image: "https://images.pexels.com/photos/10153721/pexels-photo-10153721.jpeg",
    },
    {
        key: "boxes",
        name: "بوكسات الجمعة",
        icon: "fa-box",
        image: "https://images.pexels.com/photos/6086/food-salad-healthy-vegetables.jpg",
    },
];

export const CATEGORY_MAP = Object.fromEntries(CATEGORIES.map((c) => [c.key, c]));

export const HERO_IMAGE =
    "https://images.pexels.com/photos/7497253/pexels-photo-7497253.jpeg";
